module.exports = {
      id: "comm-spiritual-usage",
      viewBox: "0 0 271.278 58.643",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-spiritual",
      toString: function () {
        return this.url;
      }
    }